import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: si retour du callback OAuth Google, on saute le /me —
    // AuthCallback échange le session_id et établit la session d'abord.
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    api.get("/auth/me")
      .then((res) => setUser(res.data?.user === null ? false : res.data))
      .catch(() => setUser(false));
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
